export default __webpack_public_path__ + "static/media/do-1.a138fcc6.jpg";